import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import authAsSaga from './authAs/saga';
import staticViewsSaga from './staticViews/saga';
import mySubjectsSaga from './staticViews/mySubjects/saga';
import subjectsCardsSaga from './staticViews/subjectsCards/saga';
import studentsSaga from './staticViews/students/saga';
import dynamicTabsSaga from './dynamicTabs/saga';
import stronaPrzedmiotuSaga from './dynamicTabs/stronaPrzedmiotu/saga';
import stronaStudentaSaga from './dynamicTabs/stronaStudenta/saga';
import kartaPrzedmiotuSaga from './dynamicTabs/kartaPrzedmiotu/saga';
import marksSaga from './marks/saga';
import utilitySaga from './utility/saga';
import appConfig from './appConfig/saga';
import studentFinderSaga from './staticViews/studentFinder/saga';

export default function* rootSaga(): Generator {
  yield all([
    authSaga(),
    authAsSaga(),
    staticViewsSaga(),
    mySubjectsSaga(),
    subjectsCardsSaga(),
    dynamicTabsSaga(),
    stronaPrzedmiotuSaga(),
    kartaPrzedmiotuSaga(),
    stronaStudentaSaga(),
    studentsSaga(),
    marksSaga(),
    utilitySaga(),
    appConfig(),
    studentFinderSaga(),
  ]);
}
